export default __webpack_public_path__ + "static/media/4.d1e3dd03.png";